<template>
    <div>
		<!-- TOP -->
		<div v-if="isLoaded" class="leaderboard__list-container">
			<div
				class="leaderboard__list-item list primary-list"
				v-for="(item, index) in amount"
				:key="index"
			>
				<div class="list__order center-box">{{ index + 1 }}.</div>
				<div v-if="scores[index] && scores[index].name" class="list__name">
					{{ scores[index].name }}
				</div>
				<div v-else class="list__name">...</div>
				<div
					v-if="scores[index] && scores[index].level"
					class="list__level center-box"
					:style="{backgroundImage: `url(${require(`../assets/levels/${scores[index].level}/player.png`)}`}"
				>
				</div>
				<div
					v-else
					class="list__level center-box"
					:style="{backgroundImage: `url(${require(`../assets/levels/1/player.png`)}`}"
				>
				</div>
				<div
					v-if="scores[index] && scores[index].count"
					class="list__count center-box"
				>
					{{ scores[index].count }}
				</div>
			</div>
		</div>
		<div v-else class="leaderboard__list-container">
			<div
				class="leaderboard__list-item list"
				v-for="(item, index) in amount"
				:key="index"
			></div>
		</div>
    </div>
</template>

<script>
    export default {
        props: ['amount', 'isLoaded', 'scores']
    }
</script>

<style lang="scss" scoped>

</style>